import './_NoAvailableFeed.scss';
import Card from 'react-bootstrap/Card';
import Button from '../../../../ntisui/Atoms/Buttons';
import { ButtonVariant } from '../../../template/types/IHeader';
import { litrals } from '../../../../../constants/Litrals';
import { useHistory } from 'react-router-dom';
import { INoFeed } from '../types/INoFeed';

const NoAvailableFeed = (props: INoFeed) => {
  const history = useHistory();
  return (
    <Card
      className="noavailabledatafeed-card-container"
      data-testid="noavailabledatafeed-card"
    >
      <Card.ImgOverlay className="image-overlay text-center">
        <Card.Img src={props.image} alt="Card image" />
        <Card.Text className="card-text">{props.message}</Card.Text>
      </Card.ImgOverlay>
      <Button
        className="card-button"
        onClick={() => history.push('/subscriberportal/subscriberdatafeed')}
        variant={ButtonVariant.Primary}
        label={litrals.goback}
      />
    </Card>
  );
};
export default NoAvailableFeed;
